var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "li",
    {
      class: { strikethrough: _vm.complete },
      attrs: { id: "reminder-item-container" },
    },
    [
      _c("div", { staticClass: "followup-mark-as-completed" }, [
        _c(
          "div",
          { staticClass: "pretty p-jelly p-primary p-icon p-centered m-0" },
          [
            _c("input", {
              attrs: { type: "checkbox" },
              on: { change: _vm.handleMarkAsComplete },
            }),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "state p-success p-primary-alt" },
              [
                _c("icon", { staticClass: "icon", attrs: { name: "check" } }),
                _vm._v(" "),
                _c("label"),
              ],
              1
            ),
          ]
        ),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "followup-content" },
        [
          _c(
            "div",
            {
              directives: [
                {
                  name: "b-tooltip",
                  rawName: "v-b-tooltip.html",
                  value: _vm.activityDescriptionTooltipOptions,
                  expression: "activityDescriptionTooltipOptions",
                  modifiers: { html: true },
                },
              ],
              staticClass: "description",
            },
            [_c("span", { domProps: { innerHTML: _vm._s(_vm.description) } })]
          ),
          _vm._v(" "),
          _c(
            "b-row",
            { staticClass: "mt-1", attrs: { "no-gutters": "" } },
            [
              _c("b-col", { attrs: { cols: "6" } }, [
                _c(
                  "div",
                  {
                    ref: "popoverTarget",
                    staticClass: "tooltip-target no-outline",
                    attrs: { tabindex: "-1" },
                  },
                  [
                    _c(
                      "a",
                      {
                        staticClass:
                          "calendar-time clickable position-relative text-primary",
                      },
                      [
                        _c(
                          "span",
                          { staticClass: "small", class: _vm.calendarClass },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(_vm.calendarInfo.text) +
                                "\n            "
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _vm.calendarInfo.key === "active"
                          ? _c("span", { staticClass: "small" }, [
                              _vm._v(
                                "\n              @ " +
                                  _vm._s(_vm.formattedScheduledTime) +
                                  "\n            "
                              ),
                            ])
                          : _vm._e(),
                      ]
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  [
                    _c(
                      "b-popover",
                      {
                        ref: "popover",
                        attrs: {
                          target: _vm.getPopoverTarget,
                          show: _vm.scheduledDatePopoverOpen,
                          container: "reminders-popover",
                          triggers: "click",
                          placement: "bottom",
                          boundary: "viewport",
                          "custom-class":
                            "inline-scheduled-date datepicker-popover",
                        },
                        on: {
                          "update:show": function ($event) {
                            _vm.scheduledDatePopoverOpen = $event
                          },
                        },
                      },
                      [
                        _c("datepicker-input", {
                          attrs: {
                            "with-input": false,
                            value: _vm.scheduledDate,
                            "future-date": "",
                          },
                          on: { change: _vm.handleScheduledDateChange },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]),
              _vm._v(" "),
              _c("b-col", { attrs: { cols: "6" } }, [
                _c(
                  "div",
                  {
                    staticClass:
                      "d-flex flex-row align-items-center justify-content-end px-3",
                  },
                  [
                    _c(
                      "span",
                      {
                        staticClass:
                          "bold text-regular-gray tiny text-uppercase mr-2 mt-0",
                      },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(
                              _vm.$t("client-profile.messages.assignedTo")
                            ) +
                            ":\n          "
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c("avatar-tooltip", {
                      ref: "avatarTooltip",
                      attrs: {
                        "visible-data": _vm.firstThreeAssignees,
                        "tooltip-data": _vm.assigneesValues,
                        placement: "right",
                        "empty-message": _vm.$t(
                          "client-profile.messages.noAsignees"
                        ),
                      },
                    }),
                  ],
                  1
                ),
              ]),
            ],
            1
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }